import { Injectable, Injector } from "@angular/core";
import * as utils from '../../../../helpers/utils';
import { BASE_URL } from '../../../../services/base-service/api.service';
import { AppUrls } from '../../../../services/urls';
import { CampaignService } from '../../../../services/shared/campaign.service';

@Injectable()
export class CampaignTaskUIService {
    baseUrl: string;

    constructor(
        private injector: Injector,
        private campaignService: CampaignService
    ) {
        this.baseUrl = this.injector.get(BASE_URL);
    }

    approveCampaign(campaignId) {
        return this.campaignService.create(null, { campaignId: campaignId }, AppUrls.APPROVE);
    }

    rejectCampaign(campaignId) {
        return this.campaignService.create(null, { campaignId: campaignId }, AppUrls.REJECT);
    }


}
